import { render, staticRenderFns } from "./EditConvoglio.vue?vue&type=template&id=8befd272&scoped=true&"
import script from "./EditConvoglio.vue?vue&type=script&lang=js&"
export * from "./EditConvoglio.vue?vue&type=script&lang=js&"
import style0 from "./EditConvoglio.vue?vue&type=style&index=0&id=8befd272&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8befd272",
  null
  
)

export default component.exports